import { render, staticRenderFns } from "./newHistogramCharts.vue?vue&type=template&id=36dd1fd0&scoped=true"
import script from "./newHistogramCharts.vue?vue&type=script&lang=js"
export * from "./newHistogramCharts.vue?vue&type=script&lang=js"
import style0 from "./newHistogramCharts.vue?vue&type=style&index=0&id=36dd1fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dd1fd0",
  null
  
)

export default component.exports